import { Injectable } from '@angular/core';
import { AUTH_LOGIN, AUTH_LOGOUT, Host } from './endpoint-api';

/**
 *Esta clase contiene todas las API URL de la aplicación haciendo uso de la clase Host,
 de esta manera solo se accede a los valores de los objecto y la ulr final ya se encuentra calculada.
 */
@Injectable({ providedIn: 'root' })
export class EndPointApiService extends Host {
	readonly AUTH = {
		login: `${this.getUrl()}${AUTH_LOGIN}`,
		logout: `${this.getUrl()}${AUTH_LOGOUT}`,
		linkRecovery: `${this.getUrl()}${AUTH_LOGIN}/linkRecovery`,
		refresh: `${this.getUrl()}${AUTH_LOGIN}/refresh`,
		registerDevice: `${this.getUrl()}${AUTH_LOGIN}/registerdevice`
	};

	readonly SHARED = {
		email: `${this.getUrl()}/share/email`,
		client2F: `${this.getUrl()}/share/client2F`
	};

	readonly INQUIRIES = {
		accounts: `${this.getUrl()}/inquiries/accounts`,
		listAccount: `${this.getUrl()}/inquiries/listaccounts`,
		listDebitCard: `${this.getUrl()}/inquiries/listDebitCards`,
		listbanks: `${this.getUrl()}/inquiries/listbanks`,
		accountDetailMovements: `${this.getUrl()}/inquiries/accounts/detail/movements`,
		accountDetailLends: `${this.getUrl()}/inquiries/accounts/detail/lends`,
		operations: `${this.getUrl()}/inquiries/operations`,
		termDeposits: `${this.getUrl()}/inquiries/termdeposits`,
		termDepositsCampaign: `${this.getUrl()}/inquiries/termdeposits/campaigns-dpf`,
		getDepositsCampaignDetail: `${this.getUrl()}/inquiries/termdeposits/campaigns-dpf`,
		schedulledSavingQuotas: `${this.getUrl()}/inquiries/schedulledSavingQuotas`,
		currencyExchange: `${this.getUrl()}/inquiries/currencyexchange`,
		presettlementss: `${this.getUrl()}/inquiries/presettlementss`,
		getTermDepositsAccountGift: `${this.getUrl()}/inquiries/termdeposits/cuenta-regalo`
	};

	readonly CONFIGURATIONS = {
		operationsActualizarTarjeta: `${this.getUrl()}/configurations/debitCardUpdate`,
		operationsBloqueoTarjeta: `${this.getUrl()}/configurations/debitCardBlock`,
		operationsUpdate: `${this.getUrl()}/configurations/operationsUpdate`,
		validateUserPacinet: `${this.getUrl()}/configurations/validateUserPacinet`,
		validateUserAnswersPacinet: `${this.getUrl()}/configurations/validateUserAnswersPacinet`,
		operationsUpdateEmailPhone: `${this.getUrl()}/configurations/updateEmailPhone`,
		operationsUpdatePreference: `${this.getUrl()}/configurations/userPreference`,
		updatePassword: `${this.getUrl()}/configurations/updatePassword`,
		updatePasswordRecovery: `${this.getUrl()}/configurations/updatepasswordRecovery`,
		updateImageProfile: `${this.getUrl()}/configurations/uploadavatar`,
		personData: `${this.getUrl()}/configurations/personData`, // por definir
		updatePerson: `${this.getUrl()}/configurations/updatePerson`, // por definir
		iquirieslocation: `${this.getUrl()}/configurations/inquiries/location`, // por definir
		realUpdatePassword: `${this.getUrl()}/configurations/realUpdatePassword`,
		updateFastCashConfig: `${this.getUrl()}/configurations/fastcashconfig`
	};

	readonly TRANSFER = {
		registerBetweenAccount: `${this.getUrl()}/transfer/register/betweenacc`,
		registerOtherAccount: `${this.getUrl()}/transfer/register/otheracc`,
		registerToBank: `${this.getUrl()}/transfer/register/tobank`,
		registerFromBank: `${this.getUrl()}/transfer/register/frombank`,
		validateAccount: `${this.getUrl()}/transfer/validate/account`,
		validateAmount: `${this.getUrl()}/transfer/validate/amount`,
		registerFavorite: `${this.getUrl()}/transfer/favorite`,
		listFavorites: `${this.getUrl()}/transfer/favorite?personId=`,
		deleteFavorite: `${this.getUrl()}/transfer/favorite?id=`,
		registerCtsWithdrawal: `${this.getUrl()}/transfer/register/ctsWithdrawal`
	};

	readonly GENERIC = {
		parameters: `${this.getUrl()}/generic/parameters`,
		listAllCombos: `${this.getUrl()}/generic/combos/0`,
		plazoAhorroProgramadoSoles: `${this.getUrl()}/generic/combos/100`,
		plazoAhorroProgramadoDolares: `${this.getUrl()}/generic/combos/101`,
		ubigeo: `${this.getUrl()}/generic/combos/ubigeos/`,
		currency: `${this.getUrl()}/generic/currency`
	};

	readonly LOANS = {
		requirements: `${this.getUrl()}/loans/requirementspsf`,
		simulator: `${this.getUrl()}/loans/simulatorpsf`,
		account: `${this.getUrl()}/inquiries/accountpsf`,
		reason: `${this.getUrl()}/loans/ReasonPSF`,
		savingAccount: `${this.getUrl()}/inquiries/savingaccount`
	};

	readonly KASNET = {
		idtransaccion: `${this.getUrl()}/kasnet/idtransaccion`,
		categorias: `${this.getUrl()}/kasnet/categorias`,
		empresaCategoria: `${this.getUrl()}/kasnet/empresas-categoria`,
		serviciosCategoria: `${this.getUrl()}/kasnet/servicios-categoria`,
		pagoRecibo: `${this.getUrl()}/kasnet/pago-recibo`
	};

	readonly PAYMENT = {
		contributions: `${this.getUrl()}/payment/list/contributions`,
		loans: `${this.getUrl()}/payment/list/loans`,
		registerContribution: `${this.getUrl()}/payment/register/contribution`,
		registerLoans: `${this.getUrl()}/payment/register/loan`,
		quotasScheduled: `${this.getUrl()}/payment/quotasScheduled`,
		interestCalculator: `${this.getUrl()}/payment/InterestCalculator`,
		minimunOpening: `${this.getUrl()}/payment/minimunOpening`,
		registerCancelation: `${this.getUrl()}/payment/register/cancelation`,
		registerInterest: `${this.getUrl()}/payment/register/interest`,
		registerTermDeposits: `${this.getUrl()}/payment/registerTermDeposits`,
		listContribution: `${this.getUrl()}/payment/list/contributions`,
		allLoanPayment: `${this.getUrl()}/payment/allLoanPayment`,
		preCancelationData: `${this.getUrl()}/payment/preCancelationData`,
		schedulledSavingCancel: `${this.getUrl()}/payment/schedulledSavingCancel`,
		schedulledSavingPayQuota: `${this.getUrl()}/payment/quotaSchedulledSavingPay`
	};

	readonly ACCOUNT = {
		savingsNew: `${this.getUrl()}/accounts/savings/new`,
		openCTS: `${this.getUrl()}/accounts/openCts`,
		schedulled: `${this.getUrl()}/accounts/savings/schedulled`,
		inquiryRuc: `${this.getUrl()}/accounts/rucInquiry`,
		scheduledNew: `${this.getUrl()}/accounts/savings/schedulled`,
		savingsGift: `${this.getUrl()}/accounts/savings/gift`
	};
}
